import { ZGenericObject } from "@/types/types";
import { MouseEvent } from "react";
import { toast } from "sonner";

export async function copyTextToClipboard(textToCopy: string, successMessage?: string) {
  await navigator.clipboard.writeText(textToCopy);
  toast.success(successMessage || "Text copied to the clipboard.");
}

// Open social link in a pop-up window
export function openInFloatingWindow(url: string) {
  const width = 600;
  const height = 400;
  const top = window.innerHeight / 2 - height / 2 + 50;
  const left = window.innerWidth / 2 - width / 2;

  window.open(url, "_blank", `width=${width},height=${height},top=${top},left=${left},resizable=yes,scrollbars=yes`);
}

export function scrollToElement(
  e: MouseEvent<HTMLAnchorElement, globalThis.MouseEvent>,
  containerId: string,
  elementId: string,
  scrollMargin: number = 128,
) {
  e.preventDefault();

  const scrollContainer = document.getElementById(containerId);
  const targetElement = document.getElementById(elementId);

  if (scrollContainer && targetElement) {
    const containerRect = scrollContainer.getBoundingClientRect();
    const targetRect = targetElement.getBoundingClientRect();

    const scrollPosition = targetRect.top - containerRect.top + scrollContainer.scrollTop - scrollMargin;

    scrollContainer.scrollTo({
      top: scrollPosition,
      behavior: "smooth",
    });
  }
}

export function exportToCSV<T extends ZGenericObject>(data: T[], filename: string) {
  if (data.length === 0) {
    console.error("No data to export.");
    return;
  }

  const headers = Object.keys(data[0]);

  const csvContent = [headers, ...data.map((row) => headers.map((header) => row[header] ?? ""))]
    .map((row) => row.join(","))
    .join("\n");

  const blob = new Blob([csvContent], { type: "text/csv" });

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;

  document.body.appendChild(link);
  link.click();

  document.body.removeChild(link);
}
